/*
* OfferReducer
*/

import { fromJS } from 'immutable';
import {
  GET_OFFER,
  GET_CHILD_OFFER,
  OFFER_RECEIVED,
  SEND_QUOTE,
  QUOTE_SENDED,
} from './constants';

// The initial state of the App
export const initialState = fromJS({
  offer: [],
  childOffer: {},
  quote: {},
});

function offersReducer(state = initialState, action) {
  switch (action.type) {
    case GET_OFFER:
      return state.set('code', action.code).set('loading', true);
    case GET_CHILD_OFFER:
      return state.set('childOffer', action.childOffer);
    case OFFER_RECEIVED:
      return state.set('offer', action.offer).set('loading', false);
    case SEND_QUOTE:
      return state.set('quote', action.quote).set('sending', true);
    case QUOTE_SENDED:
      return state
        .set('quotationCode', action.quote.code)
        .set('submitted', true)
        .set('sending', false);
    default:
      return state;
  }
}

export default offersReducer;
